import ufeApi from 'services/api/ufeApi';
import { gqlClient } from 'services/api/gql/gqlClient';
import { UpdateSmsNotification } from 'constants/gql/mutations/checkout/updateSmsNotification.gql';

/**
 * Updates SMS signup notification preferences for an order.
 * Routes to OIS GraphQL (UpdateSmsNotification) or legacy OXS REST based on oisMigration feature flags.
 *
 * @param {Object} input - SMS signup data (e.g., { orderId, phoneNumber, smsOptIn })
 * @returns {Promise<Object>} The SMS notification update response
 * @throws {Error} Throws with errorCode=-1 and errorMessages for OIS non-SUCCESS responses
 * @throws {Object} Throws raw error object for OXS errors
 */
const setSmsSignup = async input => {
    const oxsUrl = '/api/checkout/orders/smsUpdate';

    const globalEnabled = Sephora?.configurationSettings?.oisMigration?.global?.isEnabled;
    const modificationEnabled = Sephora?.configurationSettings?.oisMigration?.modification?.isEnabled;

    if (globalEnabled && modificationEnabled) {
        const data = await gqlClient.query({
            operationName: 'UpdateSmsNotification',
            query: UpdateSmsNotification,
            variables: { input }
        });

        const result = data?.updateSmsNotification;

        if (result?.responseCode && result.responseCode !== 'SUCCESS') {
            const error = new Error(result.message || 'Set SMS signup failed');
            error.errorCode = -1;
            error.responseCode = result.responseCode;
            error.errorMessages = result.message ? [result.message] : [];

            throw error;
        }

        return result;
    }

    const data = await ufeApi.makeRequest(oxsUrl, {
        method: 'POST',
        body: JSON.stringify(input)
    });

    if (data?.errorCode) {
        throw data;
    }

    return data;
};

export default setSmsSignup;
